















import { Vue, Component } from "vue-property-decorator";
import WebinarForm from "@/components/webinars/WebinarForm.vue";

@Component({
  components: { WebinarForm }
})
export default class WebinarNew extends Vue {}
